// extracted by mini-css-extract-plugin
export var grid = "RelatedBlogPosts-module--grid--c8855";